/** @format */

export interface PlpInGridSponsoredProduct {
  campaign_id?: number;
  click_tracker: string;
  excludeForSale?: boolean;
  impression_id?: string;
  impression_tracker: string;
  isCriteo: true;
  lineItemId: string;
  onBasketChangeBeacon: string;
  onWishlistBeacon: string;
  product: PlpDisplayableProduct;
  product_id: string;
  sponsored: true;
  view_tracker?: string;
  isComingSoon?: boolean;
}

export interface PlpDisplayableProduct {
  Color: string[];
  SaleColor?: string[];
  SkuCount?: number;
  CustomerRating: number;
  ID: string;
  ImageURL: string;
  Name: string;
  ReviewCount?: string;
  URL?: string;
  WCSIdentifier?: string;
  badge?: string;
  mapPriceIndicator: number;
  maxlistprice: string;
  maxmapprice: string;
  maxofferprice: string;
  minlistprice: string;
  minmapprice: string;
  minofferprice: string;
  nikeConnected?: string;
  offerprice?: string;
  onlineInventoryMessage?: string;
  priceIndicator?: 1 | 0;
}
